import SmartTips from './SmartTips';

export default SmartTips;
